module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "int",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#aint"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ve been overweight for the majority of my life, and I know the roller coaster of dieting all too well: Working hard, eating “right,” and yet always staying hungry. When I first heard of the ketogenic diet, I thought it was a crazy fad and didn’t think twice about it. It wasn’t until almost a year later, when I stumbled upon it again and heard of people who followed it not only losing weight but reversing ailments such as type 2 diabetes and high-blood pressure, that I was tempted to give it a try.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It sounded too good to be true, and the basis of the diet was contrary to everything I was taught.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("But I was overweight, borderline obese, and I knew I had to make a change or I was headed for a lifetime of medications to keep my blood pressure, blood sugars, and fats in check. Coupled with a family history of coronary disease and hypertension, the cards were stacked against me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("I did some further research, and the science behind it was sound. I told myself I would give it an honest try for three months, and then I’d reevaluate. I still had doubts, so I had blood tests done along the way and knew if there was any contrary indication, I would discontinue the diet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("That decision was almost two years ago, and I haven’t looked back. My blood work is normal—in fact, it’s great. I’ve lost close to 45 pounds on a 5’3” frame and feel better than ever. I don’t need to lose any more weight, but I’ve decided to maintain a ketogenic way of eating because I like the way I feel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Before starting the ketogenic diet, I had the great fortune of picking up an electric pressure cooker. Since then, I have had many tasty successes and my cooking style has changed somewhat. I’m happy that pressure cooking has made preparing foods for the ketogenic diet faster and easier, and I hope that you find the same too!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Note: I strongly suggest you consult a medical professional who is familiar with the diet and its risks, along with your medical history, to see if this diet is suitable for you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e009d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Introduction.vue
// module id = 72
// module chunks = 0